import type { JiraSeverCreatePayload } from 'types/users';

export const validateServerCreatePayload = (payload: JiraSeverCreatePayload) => {
  return !!payload.client_id &&
    !!payload.client_secret &&
    !!payload.jira_server_url;
}
